module.exports = __webpack_public_path__ + "img/partner_9.b3537455.png";